/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { GET, POST } from '../../../utils/HttpRequests';
import DaysDropDown from './DaysDropDown';
import CronTimeDropDown from './CronTimeDropDown';
import eventsList from './JobConstants';

export default function ScheduledJobScheduler() {
  const appUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    job_name: '', event_id: '', inbox_template: '', push_template: '', days: '', remainder_count: '', time_interval: '', status: '', template_type: '', template: '',
  });
  const [createFormData, setCreateFormData] = useState({
    job_name: '', event_id: '', days: '', remainder_count: '', time_interval: '', status: '', template_type: '', template: '', cron_at: '',
  });
  // eslint-disable-next-line no-unused-vars
  const [pageNo, setPageNumber] = useState(1);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [pushTempates, setPushTemplates] = useState([]);
  const [jobs, setJobs] = useState([]);

  const fetchInboxAndPushTemplates = async () => {
    try {
      const smsUrl = `${appUrl}admin/console/sms-templates-types`;
      const pushUrl = `${appUrl}admin/console/push-templates-types`;
      const jobsUrl = `${appUrl}admin/console/scheduled-jobs`;
      const smsRes = await GET(smsUrl);
      const pushRes = await GET(pushUrl);
      const jobsRes = await GET(jobsUrl);
      setSmsTemplates(smsRes?.data?.response.templates);
      setPushTemplates(pushRes?.data?.response?.templates);
      setJobs(jobsRes?.data?.response?.jobs);
    } catch (err) {
      console.error(err.message);
    }
  };

  const fetchFilteredJobs = async () => {
    const jobsUrl = `${appUrl}admin/console/scheduled-jobs`;
    const params = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== '') {
        params[key] = formData[key];
      }
    });
    const result = await GET(jobsUrl, params);
    setJobs(result?.data?.response?.jobs);
  };
  const createJob = async (e) => {
    e.preventDefault();
    console.log('clicked');
    const body = createFormData;
    eventsList.forEach((event) => {
      if (event.event_id === createFormData.event_id) {
        body.event_name = event.event_name;
      }
    });
    const response = await POST(`${appUrl}admin/console/v2_job`, body);
    console.log(response);
  };

  useEffect(() => { fetchInboxAndPushTemplates(); }, [pageNo]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  const onFormChange = (e) => {
    setCreateFormData({ ...createFormData, [e.target.id]: e.target.value });
  };

  const displayData = (
    <td colSpan="7"><p style={{ textAlign: 'center' }}> No Records Found </p></td>
  );
  const jobsHTML = jobs && jobs.length > 0 ? jobs.map((job) => (
    <>
      <tr key={Math.random()}>
        <td title={job.job_name}>{job.job_name || '-'}</td>
        <td title={job.event_name}>{job.event_name || '-'}</td>
        <td title={job.days}>{job.days || '-'}</td>
        <td title={job.remainder_count}>{job.remainder_count || '-'}</td>
        <td title={job.time_interval}>{job.time_interval || '-'}</td>
        <td title={job.status}>{job.status || '-'}</td>
        <td title={job.template_type}>{job.template_type || '-'}</td>
      </tr>
    </>
  ))
    : (
      <tr>
        {displayData}
      </tr>
    );

  return (
    <div style={{
      display: 'flex', padding: '1%', justifyContent: 'space-between', flexWrap: 'wrap', boxShadow: 'none',
    }}
    >
      <div style={{ flexBasis: '100%' }}>
        <form className="form-horizontal">
          <div style={{ display: 'flex', paddingRight: '10%', margin: '1% 0%' }}>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="event_id"
                onChange={onChange}
                value={formData.event_id}
              >
                <option value="" selected="selected">
                  Target Users
                </option>
                {eventsList.map((list) => <option value={list.event_id}>{list.event_name}</option>)}
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="days"
                onChange={onChange}
                value={formData.days}
              >
                <option value="" selected="selected">
                  Select Days
                </option>
                <DaysDropDown />
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="remainder_count"
                onChange={onChange}
                value={formData.remainder_count}
              >
                <option value="" selected="selected">
                  Select Reminder Count
                </option>
                {[...Array(7).keys()].map((day) => <option value={day}>{day}</option>)}
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="time_interval"
                onChange={onChange}
                value={formData.time_interval}
              >
                <option value="" selected="selected">
                  Select Start/End
                </option>
                <option value="start">Start</option>
                <option value="end">End</option>
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="status"
                onChange={onChange}
                value={formData.status}
              >
                <option value="" selected="selected">
                  Select Status
                </option>
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">InActive</option>
                <option value="failed">Failed</option>
              </select>
            </div>
            <div style={{ display: 'flex' }}>
              <Button
                variant="danger"
                onClick={fetchFilteredJobs}
                className="inputs-fl-1"
                style={{ marginRight: '5%' }}
              >
                Search
              </Button>
            </div>
          </div>
        </form>

        <div style={{ flexBasis: '100%' }}>
          <>
            <div>
              <center>
                <h4>
                  Total(Showing in table):
                  &nbsp;
                  {' '}
                  {jobs.length}
                </h4>
              </center>
            </div>
            <div className="table-responsive bn">
              <table className="table">
                <thead className="thad-dark">
                  <tr style={{ textTransform: 'capitalize' }}>
                    <th>Job Name</th>
                    <th>Target Users</th>
                    <th>Days</th>
                    <th>Reminder Count</th>
                    <th>Start / End</th>
                    <th>status</th>
                    <th>Notification Type</th>
                  </tr>
                </thead>
                <tbody>
                  {jobsHTML}
                </tbody>
              </table>
            </div>
          </>
          <div>
            <h4 style={{ paddingRight: '5px' }}>
              Create a new job
            </h4>
          </div>
          <form className="form-horizontal" onSubmit={createJob}>
            <div style={{ display: 'flex', paddingRight: '10%', margin: '1% 0%' }}>
              <div className="inputs-fl-1">
                <input
                  type="text"
                  name="job_name"
                  className="form-control"
                  id="job_name"
                  value={createFormData.job_name}
                  placeholder="Enter Job Name"
                  onChange={onFormChange}
                  required
                />
              </div>
              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="event_id"
                  onChange={onFormChange}
                  value={createFormData.event_id}
                  required
                >
                  <option value="" selected="selected">
                    Target Users
                  </option>
                  {eventsList.map(
                    (list) => <option value={list.event_id}>{list.event_name}</option>,
                  )}
                </select>
              </div>
              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="days"
                  onChange={onFormChange}
                  value={createFormData.days}
                  required
                >
                  <option value="" selected="selected">
                    Select Days
                  </option>
                  <DaysDropDown />
                </select>
              </div>
              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="remainder_count"
                  onChange={onFormChange}
                  value={createFormData.remainder_count}
                  required
                >
                  <option value="" selected="selected">
                    Select Reminder Count
                  </option>
                  {[...Array(7).keys()].map((day) => <option value={day}>{day}</option>)}
                </select>
              </div>

              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="time_interval"
                  onChange={onFormChange}
                  value={createFormData.time_interval}
                  required
                >
                  <option value="" selected="selected">
                    Select Start/End
                  </option>
                  <option value="start">Start</option>
                  <option value="end">End</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', paddingRight: '10%', margin: '1% 0%' }}>
              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="status"
                  onChange={onFormChange}
                  value={createFormData.status}
                  required
                >
                  <option value="" selected="selected">
                    Select Status
                  </option>
                  <option value="active">Active</option>
                  <option value="inactive">InActive</option>
                </select>
              </div>
              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="template_type"
                  onChange={onFormChange}
                  value={createFormData.template_type}
                  required
                >
                  <option value="" selected="selected">
                    Select Type
                  </option>
                  <option value="sms">SMS</option>
                  <option value="push">Push Notification</option>
                </select>
              </div>
              <div className="inputs-fl-1">
                {createFormData.template_type !== ''
                  ? createFormData.template_type === 'sms'
                    ? (
                      <select
                        className="form-control"
                        id="template"
                        onChange={onFormChange}
                        value={createFormData.template}
                        required
                      >
                        <option value="" selected="selected">
                          Select Tempate
                        </option>
                        {smsTemplates.map((template) => (
                          <option value={template.sms_type}>
                            {template.sms_type}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <select
                        className="form-control"
                        id="template"
                        onChange={onFormChange}
                        value={createFormData.template}
                        required
                      >
                        <option value="" selected="selected">
                          Select Tempate
                        </option>
                        {pushTempates.map((template) => (
                          <option value={template.push_type}>
                            {template.push_type}
                          </option>
                        ))}
                      </select>
                    )
                  : null}
              </div>
              <div className="inputs-fl-1">
                <select
                  className="form-control"
                  id="cron_at"
                  onChange={onFormChange}
                  value={createFormData.cron_at}
                  required
                >
                  <option value="" selected="selected">
                    Select Time
                  </option>
                  <CronTimeDropDown />
                </select>
              </div>
              <div style={{ display: 'flex' }}>
                <Button
                  variant="danger"
                  type="submit"
                  onSubmit={createJob}
                  className="inputs-fl-1"
                  style={{ marginRight: '5%' }}
                >
                  Create
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
